<div class="relative ig-iti-img-uploader z-10">
  <ig-expand-indicator #matMenuTrigger [matMenuTriggerFor]="menu" aria-label="open" class="absolute -left-4 top-[-13px]"
    [triggerText]="triggerText"></ig-expand-indicator>

  <mat-menu #menu="matMenu" yPosition="below" class="ig-iti-upload pt-6 pb-2 px-6 !rounded-2xl">
    <div class="flex justify-between items-center">
      <p class="text-2xl font-semibold text-gray-600" igClickStopPropagation>Change Image</p>
      <mat-icon
        class="text-gray-600 text-[14px] border-[1px] border-gray-600 flex items-center justify-center !w-4 !h-4 rounded-full cursor-pointer">
        close
      </mat-icon>
    </div>

    <ig-tab-image-link-file-selector (onImageUploaded)="onImageUploaded.emit($event)"
      [initialImg]=initialImg></ig-tab-image-link-file-selector>

  </mat-menu>
</div>
